import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';

import { first } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { difference, isEmpty } from 'lodash';

import { IValueChangedEvent, IWizardContentComponent } from '../../../../wizard.content';
import { MachineLearningResetWizardService } from '../../../../services/machine.learning/machine-learning-reset-wizard.service';
import { PaginatorComponent, ApplicationsService } from '@nrwl/common-lib';

export interface IChooseOptions {
  id?: number;
  name: string;
  description?: string;
  appData: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  subtitle?: string;
  expandable?: any; //eslint-disable-line @typescript-eslint/no-explicit-any
}

@Component({
  selector: 'nrwl-ml-select-application',
  templateUrl: './ml-select-application.component.html',
  styleUrls: ['./ml-select-application.component.scss'],
  providers: [MachineLearningResetWizardService]
})
export class MlSelectApplicationComponent
  implements IWizardContentComponent, OnInit, AfterViewInit, OnDestroy
{
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('paginator', { static: true }) paginatorComponent: PaginatorComponent;

  appsData: MatTableDataSource<any>; //eslint-disable-line @typescript-eslint/no-explicit-any
  displayedColumns: string[] = ['name'];
  appDataSubscription: Subscription;
  selectedElement: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  chosenAppOption: IChooseOptions;
  hidePaginator = true;
  defaultParams: IChooseOptions;
  chooseOptions: IChooseOptions[] = [
    {
      id: 0,
      name: 'All',
      description: 'All Applications',
      appData: {
        id: '*',
        name: 'All apps'
      }
    },
    {
      id: 1,
      name: 'Custom',
      description: 'Custom application configuration',
      subtitle: 'Select individual applications',
      appData: {},
      expandable: {
        value: false
      }
    }
  ];

  get paginatorStatus(): boolean {
    return this.hidePaginator;
  }

  constructor(private appsService: ApplicationsService) {}

  ngOnInit() {
    this.defaultParams = this.step.parent.defaultParamsById;
    if (this.defaultParams && this.defaultParams.id >= 0) {
      const id = this.defaultParams.id;
      this.onOptionClick(this.chooseOptions[id]);
      this.onRowClick(this.defaultParams.appData);
    }
  }

  ngAfterViewInit() {
    this.appDataSubscription = this.getApps()
      .pipe(first())
      .subscribe(apps => {
        const appsList = this.appsService.getUserDefinedAppsOnly(apps);
        this.appsData = new MatTableDataSource(appsList);
        this.appsData.paginator = this.paginatorComponent.paginator;
      });
  }

  // eslint-disable-next-line
  getApps(): Observable<any[]> {
    return this.appsService.getValuesAsync();
  }

  nextPage(event: PageEvent): void {
    this.appsData.paginator.pageIndex = event.pageIndex;
  }

  ngOnDestroy(): void {
    if (this.appDataSubscription) {
      this.appDataSubscription.unsubscribe();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  onOptionClick(chosenOption: any): void {
    this.chosenAppOption = this.chooseOptions[chosenOption.id];
    this.prepareForChosenAppOption(chosenOption);
    this.emitAppOptionChanges();
  }

  applyFilter(filterValue: string): void {
    this.appsData.filter = filterValue.trim().toLowerCase();

    if (this.appsData.paginator) {
      this.appsData.paginator.firstPage();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  onRowClick(data: any): void {
    this.selectedElement = data;
    this.chosenAppOption.appData = this.selectedElement;
    this.emitAppOptionChanges();
  }

  emitAppOptionChanges(): void {
    const isValid = !isEmpty(this.chosenAppOption.appData);
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'appObjectInput',
      key: 'appObject',
      newValue: this.chosenAppOption,
      isValid: isValid
    });
  }

  private prepareForChosenAppOption(chosenOption) {
    if (chosenOption.expandable) {
      chosenOption.expandable.value = true;
      this.chosenAppOption.appData = {};
      this.selectedElement = {};
      this.hidePaginator = false;
    } else {
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      const differentOpt: any = difference(this.chooseOptions, [chosenOption])[0];
      if (differentOpt.expandable) {
        differentOpt.expandable.value = false;
        this.hidePaginator = true;
      }
    }
  }
}
